import * as React from 'react';

export const headerText = <p>
	As our world faces this global pandemic, the veterinary community has been affected resulting in Lap of Love
	experiencing a higher call volume than normal. We are best able to assist pet families in need with some advance
	notice and planning. Please know that every single pet family is very important to us and we appreciate your
	patience in advance.
	<br/><br/>
	We are taking extra precautions to help you and our team remain safe. The health of our doctors and our team is as
	important to us as it is to you; <b>we will never send a sick doctor to your home.</b>

</p>;

export const warningText = <p>
	Per CDC guidelines, fully vaccinated individuals are no longer required to wear face coverings but are encouraged 
	to do so. The CDC acknowledges it is everyone’s responsibility to comply with this policy via the honor system. 
	Per CDC guidelines, people may choose to mask at any time. People with symptoms, a positive test, or exposure to 
	someone with COVID-19 should wear a mask.
</p>;

export const listContent = <>
	<ul>
		<li>
			Our doctors are not required to receive the COVID vaccine, though most have chosen to. We request, but do not 
			require, that you wear a mask when the doctor is within 6ft.
		</li>
		<li>
			We ask that you inform us if anyone who plans to be present at the time of an appointment has tested positive or 
			been symptomatic for COVID-19 within 10 days. We kindly ask that your family inform us if these circumstances 
			change prior to our appointment so that we may determine the safest way to help.
		</li>
		<li>
			This may be the only time you won’t get a hug from us! This is usually the most important part of our time
			with you, communicating our support via a hug or warm handshake, but we’re doing our best to minimize
			physical contact.
		</li>
	</ul>
</>;